'use client';

import { usePathname } from 'next/navigation';

import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { Button } from '@/components/button';

import type { ComponentProps } from 'react';
import { ANALYTICS_EVENTS } from '@/constants';

export const QuickLinksButton = ({
  title,
  ...props
}: ComponentProps<typeof Button> & {
  title: string;
}) => {
  const pathname = usePathname();

  return (
    <Button
      {...props}
      className="w-full !justify-start ring-1 ring-gray-200 hover:ring-2 hover:ring-blue-500 focus-visible:text-gray-700 focus-visible:ring-2 focus-visible:ring-pink-500 md:min-w-[220px] lg:w-auto lg:flex-col lg:justify-center"
      onClick={() => {
        trackAnalyticsEvent(ANALYTICS_EVENTS.quickLinks.selected, {
          currentLocation: pathname,
          destination: props.href as string,
          title,
        });
      }}
    >
      {title}
    </Button>
  );
};
